import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'qumra-tabs',
  styleUrl: 'qumra-tabs.css',
  shadow: true,
})
export class QumraTabs {
  @State() activeTabIndex: number = 0;

  @Prop() tabs: { label: string }[] = [
    { label: 'الوصف' },
    { label: 'المعلومات' },
    { label: 'تقييمات وآراء العملاء' }
  ];

  handleTabClick(index: number) {
    this.activeTabIndex = index;
  }

  render() {
    return (
      <div class="flex flex-col gap-11">
        <div class="flex gap-[60px]">
          <ul class="flex gap-[58px] items-center text-subColor font-[600] text-[20px]">
            {this.tabs.map((tab, index) => (
              <li
                onClick={() => this.handleTabClick(index)}
                class={`${this.activeTabIndex === index ? 'active-tab' : ''} cursor-pointer`}
              >
                {tab.label}
              </li>
            ))}
          </ul>
        </div>

        <div class="tab-content">
          <slot name={`tab-${this.activeTabIndex}`} />
        </div>
      </div>
    );
  }
}
